$(function() {
  initBrandFilter();
});


function initBrandFilter() {
  // Filter using navigation
  $(".brand-nav-item a").click(function() {
    var nav = $(this).attr("data-nav");


    // Remove & Add active class
    $(".brand-nav-item").removeClass("active");
    $(this)
      .parent()
      .toggleClass("active");

    // Hide all the results
    $(".brand-results-row").addClass("inactive");


    // Loop through the row
    $(".brand-results-row").each(function() {
      var term = $(this).attr("data-term");

      if (nav == term) {
        $(this).removeClass("inactive");
      }
    });

    // Only return false if data-toggle is brand
    if ($(this).attr("data-toggle") == "brand") {
      return false;
    }
 
    });
}

$('.designer-grid-main-mobile').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  dots: true
});



/*$('.press__content').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  dots: true,
  arrow: false
});*/

$('.featured-product-gallery-grid-main').slick({
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  prevArrow: $('.button-arrow--left'),
  nextArrow: $('.button-arrow--right'),
  responsive: [
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        prevArrow: $('.button-arrow--left'),
        nextArrow: $('.button-arrow--right'),
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('.featured-multi-column-slider').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  prevArrow: $('.left-arrow'),
  nextArrow: $('.right-arrow'),
  
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        prevArrow: $('.button-arrow--left'),
        nextArrow: $('.button-arrow--right'),
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.featured-instagram__body').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  prevArrow: $('.left-arrow-featured-image'),
  nextArrow: $('.right-arrow-featured-image'),
  
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        prevArrow: $('.button-arrow--left'),
        nextArrow: $('.button-arrow--right'),
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



/*$('.main-product__related-products-list').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  responsive: [
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        prevArrow: $('.button-arrow--left'),
        nextArrow: $('.button-arrow--right'),
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});*/

$('.mega-menu-container .mega-menu').each(function(index){
      var megaMenuValue = $(this).data("dropdown");
      $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .find('span')
        .remove();

      $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .not('.icon-search')
        .append(' <span class="icon-down-arrow"></span>')
        .addClass('mega-menu-parent')
        .addClass('dropdown_link')
        .removeClass('top_link');

      $('[data-dropdown="' + megaMenuValue + '"]').each(function(index){
        if (!$(this).hasClass('mega-menu')) {
          $(this).remove();
        }
      });

      $(this).clone().appendTo('.header .header__nav .header__nav__item');
});

$('.mega-menu-parent').on('mouseenter', function() {

      if(!$(this).hasClass('active_link')) {
        $('.dropdown_container').hide();
       $(this).find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]').show();

        $(this).addClass('active_link');
        $(this).removeClass('header__nav__item--expand-on-hover');
        $(this).removeClass('header__nav__item--expand-on-hover-single-column');
        $('.is-absolute').parent().removeClass('feature_image');
        $(this).find('.header__dropdown').remove();
        
      }
 });

$('.mega-menu-parent').on('mouseleave', function() {

      
       $(this).parents('.header__nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]').hide();
       $(this).removeClass('active_link');
        
 });

$('.mega-menu-container .mobile-mega-menu').each(function(index){
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find('span').remove();
      /*$('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <button class="button-arrow button-arrow--medium button-arrow--transparent button-arrow--left mobile-arrow"></button>').attr('data-no-instant', 'true');*/
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass('mobile-mega-menu-parent sublink');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this);
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(index){
        if (!$(this).hasClass('mobile-mega-menu')) {
          $(this).remove();
        }
      });
 });


$(document).ready(function() {
   $(".mobile-submenu-link").click(function() {
     /*alert('button clicked');*/
    
    $(".mobile-submenu-link").removeClass("active");
    $(".mobile-mega-menu ul").slideUp();
    if (!$(this).next().is(":visible")) {
        $(this).next().slideDown();
        $(this).addClass("active");
    }
  });
  

/* $('.mobile-mega-menu_block').click(function(e) {
        e.preventDefault();
       
       $(this).children('ul').slideToggle('slow', 'swing');
       $('.button-arrow--down').toggleClass('open');
       $('.menu-drawer__menu-item').toggleClass('is-active');
    });*/
});

$(document).ready(function() {
  $(".header__utils-left").click(function() {
     $(".search-form-mobile").css("display", "block");
  });
  $(".header__search__close").click(function() {
     $(".search-form-mobile").css("display", "none");
  });
  
});


function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
/*document.getElementById("defaultOpen").click();*/

/* Remove hover class from dynamic collection */

$(document).ready(function () {
   $('#hide-mobile-prev').click(function() {
       $('.splide__arrow--prev').click();
   });

   $('#hide-mobile-next').click(function() {
        $('.splide__arrow--next').click();
    });
})

